import { Text, Tooltip } from '@chakra-ui/react';
import { ILexiconField } from '@publishing-engine/domain/models';

interface Props {
  config: ILexiconField;
  marginLeft?:string
}

const LabelWithTooltip = ({ config,marginLeft }: Props) => {
  const label = (
    <Text textStyle="textContext" marginLeft={marginLeft} fontWeight="600">
      {config.label}
    </Text>
  );

  return config.tooltip ? (
    <Tooltip label={config.tooltip} hasArrow placement="top">
      {label}
    </Tooltip>
  ) : (
    label
  );
};

export default LabelWithTooltip;
